"use client";

import React, { useEffect, useRef, useState } from "react";
import svgPaths from "../../imports/svg-mjypqf21v0";
import {
  deleteCookie,
  getInitials,
  notify,
  processFile,
} from "../../utils/utils";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getReferredusers } from "../../utils/profile";
import {
  getProfile,
  logoutUser,
  logouUser,
  updateProfileData,
} from "../../utils/account";
import copyIcon from "../../Icons/copy-icon.svg";

import editIcon from "../../Icons/edit-icon.svg";
import trashRedIcon from "../../Icons/trash-red.svg";

// import imgRectangle2057 from "figma:asset/5ba1c9f266f5f9895b933b80d733a06cdfb6aa18.png";
// import { toast } from "sonner@2.0.3";
import "./style.css";
import Modal from "../Modal";
import Workspace from "../Workspace/WorkspaceInterface";
import ReferralModal from "../ReferralModal";

function Textfield({
  value,
  onChange,
  updateChange,
}: {
  value: string;
  onChange: (value: string) => void;
  updateChange: (value: string) => void;
}) {
  return (
    <div
      className="basis-0 box-border content-stretch flex flex-col gap-1 grow items-start justify-start min-h-px min-w-60 p-0 relative shrink-0"
      data-name="Textfield"
    >
      <div className="box-border content-stretch flex flex-row gap-2 h-6 items-center justify-center p-0 relative shrink-0 w-full">
        <div className="basis-0 font-['Geist:Regular',_sans-serif] font-normal grow leading-[0] min-h-px min-w-px relative shrink-0 text-[#211f26] text-[14px] text-left">
          <p className="block leading-[18px]">Full Name</p>
        </div>
      </div>
      <div className="bg-[#faf9fb] h-12 relative rounded-2xl shrink-0 w-full">
        <div className="absolute border border-[#eae7ec] border-solid inset-0 pointer-events-none rounded-2xl" />
        <div className="flex flex-row items-center justify-center relative size-full">
          <div className="box-border content-stretch flex flex-row gap-2 h-12 items-center justify-center px-4 py-2 relative w-full">
            <input
              type="text"
              value={value}
              onChange={(e) => onChange(e.target.value)}
              className="basis-0 font-['Geist:Regular',_sans-serif] font-normal grow leading-[18px] min-h-px min-w-px relative shrink-0 text-[#211f26] text-[14px] text-left bg-transparent border-none outline-none"
              onBlur={updateChange}
            />
          </div>
        </div>
      </div>{" "}
    </div>
  );
}

function Textfield1({
  value,
  onChange,
  updateChange,
}: {
  value: string;
  onChange: (value: string) => void;
  updateChange: (value: string) => void;
}) {
  return (
    <div
      className="basis-0 box-border content-stretch flex flex-col gap-1 grow items-start justify-start min-h-px min-w-60 p-0 relative shrink-0"
      data-name="Textfield"
    >
      <div className="box-border content-stretch flex flex-row gap-2 h-6 items-center justify-center p-0 relative shrink-0 w-full">
        <div className="basis-0 font-['Geist:Regular',_sans-serif] font-normal grow leading-[0] min-h-px min-w-px relative shrink-0 text-[#211f26] text-[14px] text-left">
          <p className="block leading-[18px]">Company Name</p>
        </div>
      </div>{" "}
      <div className="bg-[#faf9fb] h-12 relative rounded-2xl shrink-0 w-full">
        <div className="absolute border border-[#eae7ec] border-solid inset-0 pointer-events-none rounded-2xl" />
        <div className="flex flex-row items-center justify-center relative size-full">
          <div className="box-border content-stretch flex flex-row gap-2 h-12 items-center justify-center px-4 py-2 relative w-full">
            <input
              type="text"
              value={value}
              onChange={(e) => onChange(e.target.value)}
              className="basis-0 font-['Geist:Regular',_sans-serif] font-normal grow leading-[18px] min-h-px min-w-px relative shrink-0 text-[#211f26] text-[14px] text-left bg-transparent border-none outline-none"
              onBlur={updateChange}
            />
          </div>
        </div>
      </div>{" "}
    </div>
  );
}

function Frame17() {
  return (
    <div className="box-border content-stretch flex flex-row gap-2 h-6 items-center justify-center p-0 relative shrink-0 w-full">
      <div className="basis-0 font-['Geist:Regular',_sans-serif] font-normal grow leading-[0] min-h-px min-w-px relative shrink-0 text-[#211f26] text-[14px] text-left">
        <p className="block leading-[18px]">Email ID</p>
      </div>
    </div>
  );
}

function Lock() {
  return (
    <div className="relative shrink-0 size-6" data-name="lock">
      <svg
        className="block size-full"
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 24 24"
      >
        <g id="lock">
          <path
            d={svgPaths.p1f362000}
            id="Icon"
            stroke="var(--stroke-0, #211F26)"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
        </g>
      </svg>
    </div>
  );
}

function Frame18({ email }: { email: string }) {
  return (
    <div className="bg-[#eae7ec] h-12 relative rounded-2xl shrink-0 w-full">
      <div className="absolute border border-[#eae7ec] border-solid inset-0 pointer-events-none rounded-2xl" />
      <div className="flex flex-row items-center justify-center relative size-full">
        <div className="box-border content-stretch flex flex-row gap-2 h-12 items-center justify-center px-4 py-2 relative w-full">
          <div className="basis-0 font-['Geist:Regular',_sans-serif] font-normal grow leading-[0] min-h-px min-w-px overflow-ellipsis overflow-hidden relative shrink-0 text-[#211f26] text-[14px] text-left text-nowrap">
            <p className="[text-overflow:inherit] [text-wrap-mode:inherit]' [white-space-collapse:inherit] block leading-[18px] overflow-inherit">
              {email}
            </p>
          </div>
          <Lock />
        </div>
      </div>
    </div>
  );
}

function Textfield2({ email }: { email: string }) {
  return (
    <div
      className="basis-0 box-border content-stretch flex flex-col gap-1 grow items-start justify-start min-h-px min-w-60 p-0 relative shrink-0"
      data-name="Textfield"
    >
      <Frame17 />
      <Frame18 email={email} />
    </div>
  );
}

function Textfield3({ userId }: { userId: string }) {
  return (
    <div
      className="basis-0 box-border content-stretch flex flex-col gap-1 grow items-start justify-start min-h-px min-w-60 p-0 relative shrink-0"
      data-name="Textfield"
    >
      <div className="box-border content-stretch flex flex-row gap-2 h-6 items-center justify-center p-0 relative shrink-0 w-full">
        <div className="basis-0 font-['Geist:Regular',_sans-serif] font-normal grow leading-[0] min-h-px min-w-px relative shrink-0 text-[#211f26] text-[14px] text-left">
          <p className="block leading-[18px]">User ID</p>
        </div>
      </div>
      <div className="bg-[#eae7ec] h-12 relative rounded-2xl shrink-0 w-full">
        <div className="absolute border border-[#eae7ec] border-solid inset-0 pointer-events-none rounded-2xl" />
        <div className="flex flex-row items-center justify-center relative size-full">
          <div className="box-border content-stretch flex flex-row gap-2 h-12 items-center justify-center px-4 py-2 relative w-full">
            <div className="basis-0 font-['Geist:Regular',_sans-serif] font-normal grow leading-[0] min-h-px min-w-px overflow-ellipsis overflow-hidden relative shrink-0 text-[#211f26] text-[14px] text-left text-nowrap">
              <p className="[text-overflow:inherit] [text-wrap-mode:inherit]' [white-space-collapse:inherit] block leading-[18px] overflow-inherit">
                {userId || "-"}
              </p>
            </div>
            <Lock />
          </div>
        </div>
      </div>
    </div>
  );
}

function LogOut01() {
  return (
    <div className="relative shrink-0 size-5" data-name="log-out-01">
      <svg
        className="block size-full"
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 20 20"
      >
        <g id="log-out-01">
          <path
            d={svgPaths.p2f81c180}
            id="Icon"
            stroke="var(--stroke-0, #E5484D)"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
        </g>
      </svg>
    </div>
  );
}

function ButtonBase({ onClick }: { onClick: () => void }) {
  return (
    <button
      onClick={onClick}
      className="basis-0 bg-[#feebec] grow h-12 min-h-px min-w-px relative rounded-2xl shrink-0 hover:bg-[#fdd8da] transition-colors cursor-pointer"
      data-name="Button base"
    >
      <div className="flex flex-row items-center justify-center overflow-clip relative size-full">
        <div className="box-border content-stretch flex flex-row gap-2 h-12 items-center justify-center p-[16px] relative w-full">
          <LogOut01 />
          <div className="font-['Geist:Medium',_sans-serif] font-medium leading-[0] relative shrink-0 text-[#e5484d] text-[14px] text-center text-nowrap">
            <p className="block leading-[18px] whitespace-pre">Logout</p>
          </div>
        </div>
      </div>
    </button>
  );
}

function ButtonCmp({ onClick }: { onClick: () => void }) {
  return (
    <div
      className="box-border content-stretch flex flex-row items-start justify-start p-0 relative shrink-0 w-[120px]"
      data-name="Button_cmp"
    >
      <ButtonBase onClick={onClick} />
    </div>
  );
}

function InputFields({
  fullName,
  companyName,
  email,
  userId,
  onFullNameChange,
  onCompanyNameChange,
  onLogout,
}: {
  fullName: string;
  companyName: string;
  email: string;
  userId: string;
  onFullNameChange: (value: string) => void;
  onCompanyNameChange: (value: string) => void;
  onLogout: () => void;
}) {
  const handleUpdate = (val, field) => {
    updateProfileData({ [field]: val }).then((res) => {
      console.log(res);
      getProfile();
    });
  };

  return (
    <div className="box-border content-end flex gap-6 grow items-end justify-start min-h-px min-w-px p-0 relative shrink-0 flex-wrap">
      <Textfield
        value={fullName}
        onChange={onFullNameChange}
        updateChange={() => {
          handleUpdate(fullName, "name");
        }}
      />
      <Textfield1
        value={companyName}
        onChange={onCompanyNameChange}
        updateChange={() => {
          handleUpdate(companyName, "company");
        }}
      />
      <Textfield2 email={email} />
      <Textfield3 userId={userId} />
      <ButtonCmp onClick={onLogout} />
    </div>
  );
}

function HeaderContent({
  fullName,
  companyName,
  email,
  userId,
  profileImage,
  onFullNameChange,
  onCompanyNameChange,
  onLogout,
  referralLink,
  referredUsers,
  onCopyLink,
  setShowReferallsModal,
}: {
  fullName: string;
  companyName: string;
  email: string;
  userId: string;
  profileImage: string;
  onFullNameChange: (value: string) => void;
  onCompanyNameChange: (value: string) => void;
  onLogout: () => void;
  referralLink: string;
  onCopyLink: () => void;
  setShowReferallsModal: () => void;
  referredUsers: [];
}) {
  const profileInpRef = useRef();
  const [updatedProfile, setUpdatedProfile] = useState("");

  useEffect(() => {
    if (profileImage) {
      setUpdatedProfile("");
    }
  }, [profileImage]);

  const handleProfileChange = (input: React.ChangeEvent<HTMLInputElement>) => {
    if (input.target.files && input.target.files[0]) {
      const selectedFile = input.target.files[0];

      if (selectedFile) {
        console.log(selectedFile);
        setUpdatedProfile(selectedFile);
        let reader = new FileReader();
        let img = document.getElementById("image1");
        img.title = selectedFile.name;
        reader.onload = function (event) {
          img.src = event.target.result;
        };
        reader.readAsDataURL(selectedFile);
      }

      processFile(selectedFile)
        .then((res) => {
          updateProfileData({ image: res }).then((res) => {
            console.log(res);
            getProfile();
          });
        })
        .catch((err) => {
          console.log(err);
          notify(
            "Some error occurred. Please try with a different image file",
            "error"
          );
        });
    }
  };

  const handleRemoveProfileImg = () => {
    updateProfileData({ imageUrl: "" }).then((res) => {
      console.log(res);
      getProfile();
    });
  };

  return (
    <div className="box-border content-stretch flex flex-row gap-6 items-center justify-start p-0 relative shrink-0 w-full">
      <div
        className="bg-center bg-cover bg-no-repeat relative rounded-[1000px] shrink-0 flex flex-col items-center gap-[16px]"
        // style={{ backgroundImage: `url('${profileImage}')` }}
      >
        <div className="border border-[#f0f1ff] border-solid inset-0 pointer-events-none rounded-[1000px] h-[120px] w-[120px]">
          <img
            id="image1"
            style={{
              width: updatedProfile ? "100%" : "0",
              height: updatedProfile ? "100%" : "0",
              position: !updatedProfile ? "absolute" : "relative",
            }}
            className=" h-full rounded-[1000px] w-full"

            //   className={styles["uploaded-image"]}
          />
          {!updatedProfile && (
            <>
              {profileImage ? (
                <img
                  className="bg-center bg-cover bg-no-repeat h-full rounded-[1000px] w-full object-cover"
                  src={profileImage}
                  alt="workspace image"
                />
              ) : (
                <div className="bg-center bg-cover bg-no-repeat h-full rounded-[1000px] shrink-0 w-full default-icon">
                  {getInitials(fullName)}
                </div>
              )}
            </>
          )}
        </div>
        <div className="profile-img-cta">
          <div
            className="icon"
            onClick={() => {
              profileInpRef.current.click();
            }}
          >
            <img src={editIcon} />

            <input
              type="file"
              ref={profileInpRef}
              onChange={handleProfileChange}
              style={{ display: "none" }}
              accept="image/*"
            ></input>
          </div>
          <div className="divider-vr-sm"></div>
          <div
            className="icon"
            onClick={() => {
              handleRemoveProfileImg();
            }}
          >
            <img src={trashRedIcon} />
          </div>
        </div>
      </div>
      <div className="profile-right-sec">
        <InputFields
          fullName={fullName}
          companyName={companyName}
          email={email}
          userId={userId}
          onFullNameChange={onFullNameChange}
          onCompanyNameChange={onCompanyNameChange}
          onLogout={onLogout}
        />
        <div className="box-border content-stretch flex flex-row gap-4 items-end justify-start p-0 relative shrink-0 w-full">
          <div className="referral-container">
            <div>Referral Link</div>

            <div
              className=" box-border content-stretch flex flex-col gap-1 grow items-start justify-start min-w-px p-0 relative  h-[48px]"
              data-name="Textfield"
            >
              <div className="bg-[#faf9fb] h-full relative rounded-2xl shrink-0 w-full">
                <div className="absolute border border-[#eae7ec] border-solid inset-0 pointer-events-none rounded-2xl" />
                <div className="flex flex-row items-center justify-center relative size-full px-4 py-2">
                  <div className="box-border content-stretch flex flex-row gap-2 h-12 items-center justify-center relative flex-[1]">
                    <input
                      type="text"
                      value={referralLink}
                      readOnly
                      className="basis-0 font-['Geist:Regular',_sans-serif] font-normal grow leading-[18px] min-h-px min-w-px relative shrink-0 text-[#211f26] text-[14px] text-left bg-transparent border-none outline-none"
                    />
                  </div>
                  <div className="copy-cta cursor-pointer" onClick={onCopyLink}>
                    <img src={copyIcon} />
                    <div className="text">Copy</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="my-referall" onClick={setShowReferallsModal}>
            My referrals
          </div>
        </div>{" "}
      </div>
    </div>
  );
}

function HeaderSection({
  fullName,
  companyName,
  email,
  userId,
  profileImage,
  onFullNameChange,
  onCompanyNameChange,
  onLogout,
  referralLink,
  referredUsers,
  onCopyLink,
  setShowReferallsModal,
}: {
  fullName: string;
  companyName: string;
  email: string;
  userId: string;
  profileImage: string;
  onFullNameChange: (value: string) => void;
  onCompanyNameChange: (value: string) => void;
  onLogout: () => void;
  referralLink: string;
  onCopyLink: () => void;
  setShowReferallsModal: () => void;
  referredUsers: [];
}) {
  return (
    <div className="backdrop-blur-md backdrop-filter bg-[rgba(255,255,255,0.64)] relative rounded-3xl shrink-0 w-full">
      <div className="absolute border border-[#ebe4ff] border-solid inset-0 pointer-events-none rounded-3xl" />
      <div className="relative size-full">
        <div className="box-border content-stretch flex flex-col gap-8 items-start justify-start p-[24px] relative w-full">
          <HeaderContent
            fullName={fullName}
            companyName={companyName}
            email={email}
            userId={userId}
            profileImage={profileImage}
            onFullNameChange={onFullNameChange}
            onCompanyNameChange={onCompanyNameChange}
            onLogout={onLogout}
            referralLink={referralLink}
            referredUsers={referredUsers}
            onCopyLink={onCopyLink}
            setShowReferallsModal={setShowReferallsModal}
          />
        </div>
      </div>
    </div>
  );
}

function Frame19() {
  return (
    <div className="box-border content-stretch flex flex-row gap-2 h-6 items-center justify-center p-0 relative shrink-0 w-full">
      <div className="basis-0 font-['Geist:Regular',_sans-serif] font-normal grow leading-[0] min-h-px min-w-px relative shrink-0 text-[#211f26] text-[14px] text-left">
        <p className="block leading-[18px]">Referral Link</p>
      </div>
    </div>
  );
}

function ButtonBase1({ onClick }: { onClick: () => void }) {
  return (
    <button
      onClick={onClick}
      className="bg-[#2d58ff] box-border content-stretch flex flex-row gap-2 h-12 items-center justify-center overflow-clip p-[16px] relative rounded-2xl shrink-0 w-[107px] hover:bg-[#1f4ae6] transition-colors cursor-pointer"
      data-name="Button base"
    >
      <div className="font-['Geist:Medium',_sans-serif] font-medium leading-[0] relative shrink-0 text-[#fcfcfd] text-[14px] text-center text-nowrap">
        <p className="block leading-[18px] whitespace-pre">Copy Link</p>
      </div>
    </button>
  );
}

function ButtonCmp1({ onClick }: { onClick: () => void }) {
  return (
    <div
      className="box-border content-stretch flex flex-row items-start justify-start p-0 relative shrink-0"
      data-name="Button_cmp"
    >
      <ButtonBase1 onClick={onClick} />
    </div>
  );
}

function HDivider() {
  return (
    <div className="h-0 relative shrink-0 w-full" data-name="H Divider">
      <div
        className="absolute bottom-full left-0 right-0 top-0"
        data-name="H Divider"
      >
        <div className="absolute bottom-[-0.5px] left-[-0.044%] right-[-0.044%] top-[-0.5px]">
          <svg
            className="block size-full"
            fill="none"
            preserveAspectRatio="none"
            viewBox="0 0 1138 2"
          >
            <path
              d="M1 1H1137"
              id="H Divider"
              stroke="var(--stroke-0, #EAE7EC)"
              strokeLinecap="round"
            />
          </svg>
        </div>
      </div>
    </div>
  );
}

function Frame2147224380() {
  return (
    <div className="box-border content-stretch flex flex-row font-['Geist:Regular',_sans-serif] font-normal gap-2 items-center justify-start leading-[0] p-0 relative shrink-0 text-[#0b081e] text-[14px] w-full">
      <div className="basis-0 flex flex-col grow justify-center min-h-px min-w-px opacity-80 relative shrink-0 text-left">
        <p className="block leading-[18px]">jane.doe@example.com</p>
      </div>
      <div className="flex flex-col justify-center opacity-80 relative shrink-0 text-nowrap text-right">
        <p className="block leading-[18px] whitespace-pre">12/05/24</p>
      </div>
    </div>
  );
}

function Frame2147224357({ referredUsers }: { referredUsers: [] }) {
  return (
    <div className="box-border content-stretch flex flex-col gap-6 items-start justify-start p-0 relative shrink-0 w-full">
      {referredUsers && referredUsers.length ? (
        <>
          {referredUsers.map((_, i) => (
            <Frame2147224380 key={i} />
          ))}
        </>
      ) : (
        <div className="flex justify-center items-center w-full h-[400px]">
          No Referred users
        </div>
      )}
    </div>
  );
}

export default function ProfileInterface() {
  const navigate = useNavigate();
  const location = useLocation();
  const globalReducer = useSelector((store: any) => store.globalReducer);
  const [fullName, setFullName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState("");
  const [userId, setUserId] = useState("");
  const [profileImage, setProfileImage] = useState("");
  const [referralCode, setReferalCode] = useState("");
  const [referralLink, setReferralLink] = useState("");
  const [referredUsers, setReferredUsers] = useState([]);
  const [showReferallsModal, setShowReferallsModal] = useState(false);

  useEffect(() => {
    getReferredusers().then((res) => {
      console.log(res);
      if (res.status && res.status.code == 0 && res.users) {
        setReferredUsers(res.users);
      }
    });
  }, []);

  useEffect(() => {
    if (globalReducer.userData) {
      const { userData } = globalReducer;
      setFullName(userData.name);
      setCompanyName(userData.company);
      setEmail(userData.email);
      setUserId(userData._id || "");
      setProfileImage(userData.imageUrl);
      setReferalCode(userData.referralCode);
    }
  }, [globalReducer.userData]);

  useEffect(() => {
    if (referralCode && referralCode.length) {
      const link = window.location.origin + "?referral_code=" + referralCode;

      setReferralLink(link);
    }
  }, [referralCode]);

  const handleLogout = () => {
    logoutUser().then((res) => {
      console.log(res);
      navigate("/login");
    });
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(referralLink);
      console.log("Referral link copied to clipboard!", referralLink);
      notify("Referral link copied to clipboard!");
    } catch (error) {
      // toast.error("Failed to copy link to clipboard");
    }
  };

  return (
    <>
      <div
        className="box-border content-stretch flex flex-col gap-[12px] items-start justify-start p-0 relative w-full"
        data-name="My Profile"
      >
        <div className="flex flex-col font-['Geist:SemiBold',_sans-serif] font-semibold justify-center leading-[0] relative shrink-0 text-[#211f26] text-[24px] text-left tracking-[-0.24px] w-full">
          <p className="adjustLetterSpacing leading-[30px] whitespace-pre font-semibold text-[18px]">
            My Profile
          </p>
        </div>
        <HeaderSection
          fullName={fullName}
          companyName={companyName}
          email={email}
          userId={userId}
          profileImage={profileImage}
          onFullNameChange={setFullName}
          onCompanyNameChange={setCompanyName}
          onLogout={handleLogout}
          referralLink={referralLink}
          referredUsers={referredUsers}
          onCopyLink={handleCopyLink}
          setShowReferallsModal={setShowReferallsModal}
        />
      </div>

      {showReferallsModal && (
        <Modal
          onClose={() => {
            setShowReferallsModal(false);
          }}
        >
          <ReferralModal
            onClose={() => {
              setShowReferallsModal(false);
            }}
            referredUsers={referredUsers}
          ></ReferralModal>
        </Modal>
      )}
    </>
  );
}
